import React, { useEffect } from 'react';
import styles from '../../styles/cards.module.css'
import {organismos} from '../../json/organismos';

const Organismos = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='container transparencia-container'>
            <div className='row'>
                <div className='col_12'>
                    <div className='transparencia_title'>
                        <h3 className={ styles.title }>
                            Organismos Descentralizados
                        </h3>
                        <hr className='hr-gob'></hr>
                    </div>
                </div>
                {
                    organismos.map((item, index)=>(
                        <div key={ index } className='col-md-4 col-sm-6 col-12'>
                            <div className={ styles.container }>
                                <h5 className={ styles.name }>
                                    { item.alias }
                                </h5>
                                <hr></hr>
                                <a className={ styles.link } href={ item.url } target='_blank' rel='noopener noreferrer'>
                                    <div className={ styles.item }>
                                        <p className={ styles.textLink }>
                                            { item.nombre }
                                        </p>
                                        <i className={`${ styles.iconLink } ${ item.icon }`} aria-hidden='true'></i>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ))
                }
        </div>
    </div>
  )
}

export default Organismos